<script>
    import {searchAndRemoveClasses, closestSelector} from "../../../commonjs/helpers";
    import {getParents} from "../../../commonjs/utils/NodeHandler";

    export default {
        name: "SectionListenersMixin",
        data () {
            return {
                eventListeners: {
                    "click": {
                        namespace: "click",
                        handler: "clickTrigger",
                    },
                    "mouseout": {
                        namespace: "mouseout",
                        handler: "mouseOutTrigger",
                    },
                    "mouseover": {
                        namespace: "mouseover",
                        handler: "mouseOverTrigger",
                    }
                },
                activeListenerKeys: [], //holds all event listener keys that have been added on the section
            }
        },
        methods: {
            createSectionListeners (eventKeys) {
                //when the events that should be added aren't declared then add them all
                if (!eventKeys) {
                    eventKeys = this.eventListeners;
                }

                for (let eventKey in eventKeys) {

                    if (!eventKeys.hasOwnProperty(eventKey)) {
                        continue;
                    }

                    let eventInfo = eventKeys[eventKey];
                    this.sectionNode.addEventListener(eventInfo.namespace,this[eventInfo.handler]);
                    this.activeListenerKeys.push(eventKey);
                }
            },
            removeSectionListeners (eventKeys) {
                //when the events that should be removed aren't declared then remove them all
                if (!eventKeys) {
                    eventKeys = this.activeListenerKeys;
                }

                for (let index in eventKeys) {

                    if (!eventKeys.hasOwnProperty(index)) {
                        continue;
                    }
                    let eventKey = eventKeys[index];

                    let eventInfo = this.eventListeners[eventKey] ? this.eventListeners[eventKey]  : null;

                    if (eventInfo) {
                        this.sectionNode.removeEventListener(eventInfo.namespace,this[eventInfo.handler]);
                    }
                }

            },
            clickTrigger (event) {
                // event.stopPropagation();
                // if ( event.target.classList.contains(this.classSelectors.elementSelected) ) {
                    this.setElementStatus({ selectedSection : null , selectedElement : null });
                // }

                // if (!this.clickEventAllowDefault) {
                //     event.preventDefault();
                // }
                // console.log("click trigger : " , this.myId , event , event.target)
                let targetNode = event.target;
                let targetId = targetNode.getAttribute("id");

                if (targetNode.dataset.targetId) {
                    // this is a temp hack to pass click handlers inside hamburger menu buttons
                    // TODO: FIX ON FIST CHANCE!!!
                    targetId = targetNode.dataset.targetId;
                }

                if (targetId && this.findNodeState(targetId)) {
                    this.findNodeState(targetId).handleClick(event);
                } else if (getParents(targetNode,'[id]')) {
                    let parentsWithId = getParents(targetNode,'[id]');

                    parentsWithId.find( parentWithId => {
                        let parentId = parentWithId.getAttribute("id");
                        if (this.findNodeState(parentId)) {
                            this.findNodeState(parentId).handleClick(event);
                            return true;
                        }
                    })
                }
            },
            mouseOutTrigger (event) {
                //negate events from other sections while one is actively focused, except click event which toggles off the focus mode
                if (this.sectionFocusModeId && this.sectionId !== this.sectionFocusModeId) {
                    return;
                }

                let targetNode = event.target;
                let targetId = targetNode.getAttribute("id");

                if (targetId && this.findNodeState(targetId)) {
                    this.findNodeState(targetId).handleMouseOut(event);
                }
            },
            mouseOverTrigger (event) {
                //negate events from other sections while one is actively focused, except click event which toggles off the focus mode
                if (this.sectionFocusModeId && this.sectionId !== this.sectionFocusModeId) {
                    return;
                }

                let targetNode = event.target;
                let targetId = targetNode.getAttribute("id");

                if (targetId && this.findNodeState(targetId)) {
                    this.findNodeState(targetId).handleMouseOver(event);
                }  else if (getParents(targetNode,'[id]')) {
                    let parentsWithId = getParents(targetNode,'[id]');

                    parentsWithId.find( parentWithId => {
                        let parentId = parentWithId.getAttribute("id");
                        if (this.findNodeState(parentId)) {
                            this.findNodeState(parentId).handleMouseOver(event);
                            return true;
                        }
                    })
                }
            },
        }
    }
</script>

